async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`);
    return response.ok ? response.json() : null;
  }
  
  function updateProductImages(productItem, url, imageSrc) {
    const primaryImage = productItem.querySelector(
      ".product-item__primary-image"
    );
    const secondaryImage = productItem.querySelector(
      ".product-item__secondary-image"
    );
    const urlElement = productItem.querySelector("a.product-item__aspect-ratio");
  
    if (urlElement) urlElement.setAttribute("href", url);
    if (primaryImage) {
      primaryImage.removeAttribute("srcset");
      primaryImage.setAttribute("src", imageSrc);
    }
    if (secondaryImage) {
      secondaryImage.removeAttribute("srcset");
      secondaryImage.setAttribute("src", imageSrc);
    }
  }
  
  function addMorePatternsLink(swatchList, productHandle) {
    const existingLinks = swatchList.parentElement.querySelectorAll(
      ".custom-more-patterns-link"
    );
    if (existingLinks.length === 0) {
      const link = document.createElement("a");
      link.href = `${window.themeVariables.routes.rootUrlWithoutSlash}/products/${productHandle}`;
      link.classList.add("custom-more-patterns-link");
      link.textContent = "+ more patterns";
      swatchList.parentNode.insertBefore(link, swatchList.nextSibling);
    }
  }
  
  function createSpinner(productItemContainer, idSuffix = "default") {
    const spinnerContainer = document.createElement("div");
    spinnerContainer.id = `custom-spinner-container-${idSuffix}`;
    spinnerContainer.style.position = "absolute";
    spinnerContainer.style.top = "0";
    spinnerContainer.style.left = "0";
    spinnerContainer.style.width = "100%";
    spinnerContainer.style.height = "100%";
    spinnerContainer.style.display = "flex";
    spinnerContainer.style.justifyContent = "center";
    spinnerContainer.style.alignItems = "center";
    spinnerContainer.style.background = "";
    spinnerContainer.style.zIndex = "10000";
  
    const spinner = document.createElement("div");
    spinner.id = `custom-spinner-${idSuffix}`;
    spinner.style.width = "50px";
    spinner.style.height = "50px";
    spinner.style.border = "5px solid #f3f3f3";
    spinner.style.borderTop = "5px solid #0f0d15";
    spinner.style.borderRadius = "50%";
    spinner.style.animation = "spin 1s linear infinite";
  
    spinnerContainer.appendChild(spinner);
    productItemContainer.style.position = "relative";
    productItemContainer.appendChild(spinnerContainer);
  
    if (!document.querySelector("#spinner-keyframes")) {
      const styleSheet = document.createElement("style");
      styleSheet.id = "spinner-keyframes";
      styleSheet.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(styleSheet);
    }
  
    return spinnerContainer;
  }
  
  function removeSpinner(spinner) {
    if (spinner && spinner.parentNode) {
      spinner.parentNode.removeChild(spinner);
      const styleSheet = document.head.querySelector("#spinner-keyframes");
      if (
        styleSheet &&
        !document.querySelector("[id^=custom-spinner-container]")
      ) {
        document.head.removeChild(styleSheet);
      }
    }
  }
  
  async function checkProductInCollection(
    collectionHandle,
    productHandle,
    variantId
  ) {
    const limit = 50;
    let page = 1;
    let allProducts = [];
    const baseUrl = `${window.themeVariables.routes.rootUrlWithoutSlash}/collections/${collectionHandle}/products.json`;
  
    try {
      while (true) {
        const apiUrl = `${baseUrl}?page=${page}&limit=${limit}`;
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
        const products = data.products || [];
        allProducts = allProducts.concat(products);
  
        if (products.length < limit) break;
        page++;
      }
  
      const productInCollection = allProducts.find(
        (product) => product.handle === productHandle
      );
  
      if (!productInCollection) return false;
  
      const isAvailable = productInCollection.variants.find(
        (each) => each.id === Number(variantId) && !!each.available
      );
  
      return !!isAvailable;
    } catch (error) {
      console.error("Error checking product in collection:", error);
      return false;
    }
  }
  
  async function promoteProductAd(source = "unknown") {
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = urlParams.get("page");
    if (currentPage && currentPage !== "1") return;
  
    const sessionProductAds = JSON.parse(
      sessionStorage.getItem("productAds") || "{}"
    );
    const productAds = sessionProductAds?.productAds || [];

    if (!productAds?.length) return;
  
    const currentCollection = window.location.pathname.replace(
      "/collections/",
      ""
    );
    const productGrid = document.querySelector(".product-list__inner");
    if (!productGrid) return;
  
    const productItems = Array.from(
      productGrid.querySelectorAll(".product-item")
    );
  
    productAds.forEach(({ handle }) => {
      const exitElement = productItems.find(
        (each) => each.getAttribute("product-handle") === handle
      );
      if (exitElement) productGrid.removeChild(exitElement);
    });
  
    const placeholders = productAds.map((_, index) => {
      const placeholder = document.createElement("product-item");
      placeholder.classList.add("product-item");
      placeholder.setAttribute("data-placeholder", `placeholder-${index}`);
      createSpinner(placeholder, `placeholder-${index}`);
      return placeholder;
    });
    placeholders.forEach((placeholder) => productGrid.prepend(placeholder));
  
    const fragment = document.createDocumentFragment();
  
    for (const {
      handle: targetProductHandle,
      variant: targetVariantId,
    } of productAds) {
      if (!targetProductHandle) continue;
  
      const productData = await fetchProduct(targetProductHandle);
      if (!productData) continue;
  
      const cacheKey = `collectionCheck_${currentCollection}_${targetProductHandle}_${targetVariantId}`;
      let isProductIncludeCollection = sessionStorage.getItem(cacheKey);
      if (isProductIncludeCollection === null) {
        if (targetVariantId) {
          isProductIncludeCollection = await checkProductInCollection(
            currentCollection,
            targetProductHandle,
            targetVariantId
          );
        } else {
          isProductIncludeCollection = true;
        }
        sessionStorage.setItem(cacheKey, isProductIncludeCollection);
      } else {
        isProductIncludeCollection = isProductIncludeCollection === "true";
      }
  
      if (!isProductIncludeCollection) continue;
  
      const productItemContainer = document.createElement("product-item");
      productItemContainer.classList.add("product-item");
      productItemContainer.setAttribute("product-handle", targetProductHandle);
  
      const spinner = createSpinner(productItemContainer, targetProductHandle);
  
      const response = await fetch(
        `${window.themeVariables.routes.rootUrlWithoutSlash}/products/${targetProductHandle}?view=main-product-item-view`
      );
      const html = await response.text();
      const productItem = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector("product-item")
  
      productItemContainer.innerHTML = productItem.innerHTML;
      Array.from(productItem.attributes).forEach(attr => {
        productItemContainer.setAttribute(attr.name, attr.value);
      });
  
      if (typeof yotpo !== "undefined" && yotpo.initialized)
        yotpo.refreshWidgets();
  
      const swatches = [
        ...productItemContainer.querySelectorAll(
          `.block-swatch-list[product-handle="${targetProductHandle}"] .block-swatch:not(.hide-swatch)`
        ),
      ];
  
      let selectedSwatchIndex = -1;
      const selectedSwatch = targetVariantId
        ? swatches.find((swatch, index) => {
            const radio = swatch.querySelector(".color-swatch__radio");
            const match =
              radio && radio.getAttribute("variant-id") === targetVariantId;
            if (match) selectedSwatchIndex = index;
            return match;
          })
        : swatches.find((swatch, index) => {
            const radio = swatch.querySelector(".color-swatch__radio[checked]");
            if (radio) {
              selectedSwatchIndex = index;
            }
            return !!radio;
          });
  
      if (selectedSwatch) {
        const radio = selectedSwatch.querySelector(".color-swatch__radio");
        const link = selectedSwatch.querySelector(".color-swatch__item");
        if (radio) radio.checked = true;
        if (link) {
          link.classList.add("color-swatch-item-active");
          updateProductImages(
            selectedSwatch.closest(".product-item"),
            link.getAttribute("href"),
            link.getAttribute("featured-image-src")
          );
        }
      }
  
      let showMorePatterns = false;
      swatches.forEach((swatch, i) => {
        const shouldDisplay = i < 4 || i === selectedSwatchIndex;
        swatch.style.display = shouldDisplay ? "block" : "none";
        if (!shouldDisplay) showMorePatterns = true;
  
        if (shouldDisplay) {
          const link = swatch.querySelector(
            ".color-swatch__item.color-swatch__item-cp-1"
          );
          const radio = swatch.querySelector(".color-swatch__radio");
          if (link && radio) {
            link.addEventListener("click", (event) => {
              event.preventDefault();
              const productItem = swatch.closest(".product-item");
  
              swatches.forEach((s) => {
                const otherLink = s.querySelector(
                  ".color-swatch__item.color-swatch__item-cp-1"
                );
                if (otherLink)
                  otherLink.classList.remove("color-swatch-item-active");
              });
  
              radio.checked = true;
              link.classList.add("color-swatch-item-active");
              updateProductImages(
                productItem,
                link.getAttribute("href"),
                link.getAttribute("featured-image-src")
              );

              // Update variant ID in the ATC form
              const variantIdInput = productItem.querySelector(".product-item-variant-id");
              const variantId = link.getAttribute("href")?.match(/variant=(\d+)/)?.[1];
              if (variantIdInput && variantId) {
                variantIdInput.value = variantId;
              }
            });
          }
        }
      });
  
      if (showMorePatterns) {
        const swatchList = productItemContainer.querySelector(
          `.block-swatch-list[product-handle="${targetProductHandle}"]`
        );
        addMorePatternsLink(swatchList, targetProductHandle);
      }
  
      removeSpinner(spinner);
  
      fragment.appendChild(productItemContainer);
    }
  
    placeholders.forEach((placeholder) => placeholder.remove());
  
    productGrid.prepend(fragment);
  }
  
  // Track AJAX requests
  let isAjaxPending = false;
  let isProcessing = false;
  let isPageLoaded = false;
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = args[0];
    if (
      typeof url === "string" &&
      url.includes("/collections/") &&
      !url.includes("/cart") &&
      !url.includes("/products.json") &&
      isPageLoaded
    ) {
      isAjaxPending = true;
      response
        .clone()
        .text()
        .then(() => {
          if (isAjaxPending && !isProcessing) {
            isProcessing = true;
            promoteProductAd("AJAX");
            isAjaxPending = false;
            isProcessing = false;
          }
        });
    }
    return response;
  };
  
  // Debounce promoteProductAd
  let lastCallTime = 0;
  const debouncePromoteProductAd = (source) => {
    const currentTime = Date.now();
    if (currentTime - lastCallTime > 500) {
      lastCallTime = currentTime;
      if (!isProcessing) {
        isProcessing = true;
        promoteProductAd(source);
        isProcessing = false;
      }
    }
  };
  
  document.addEventListener("DOMContentLoaded", () => {
    isPageLoaded = true;
    debouncePromoteProductAd("DOMContentLoaded");
  });
  
  document.addEventListener("facet:criteria-changed", () => {
    // debouncePromoteProductAd("facet:criteria-changed");
  });